export default __webpack_public_path__ + "static/media/invoice.44f5df2a.svg";